// @flow
import actionTypes from '../../actionTypes';
import { fetch } from '../../../api';

export default (initialPost: Post) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const post = initialPost.id !== undefined ?
      state.data.posts[initialPost.id] :
      state.data.posts[initialPost];
    const group = state.data.groups[post.group];

    dispatch({
      type: actionTypes.POST_DELETE,
      dataToDelete: { posts: [post] },
    });

    try {
      await fetch(
        `post/${post.id}`,
        { method: 'DELETE', query: { groupCode: group.groupCode, groupId: group.id } }
      );
    } catch (error) {
      return dispatch({
        type: actionTypes.POST_DELETE_FAILURE,
        bypassMiddleware: true,
        data: { posts: { [post.id]: post } },
        alert: { type: actionTypes.POST_DELETE_FAILURE },
        isAsynchronous: true,
      });
    }
  };
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/posts/delete.js